export default "__VITE_ASSET__BRfGdXUh__"